import Private from '.private';
export default Private()                    ;
          
	                                                                  
	                                                                    
	                                                                        
  